<div class="row page-header">
    <div class="col-12">
        <h1>AI POC <small>Purchase Order Data Extraction via Claude</small></h1>
    </div>
</div>

<div>
    <div class="row mb-3">
        <div class="col-12">
            <input type="file" #fileInput class="d-none" (change)="onFileSelected($event)" />
            <button class="btn btn-primary" (click)="triggerFileInput()" [disabled]="isProcessing">
                @if (isProcessing) {
                    <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Processing...
                } @else {
                    Upload PO
                }
            </button>
            @if (uploadedFileName && isProcessing) {
                <span class="ms-3 text-muted">Analyzing {{ uploadedFileName }}...</span>
            }
        </div>
    </div>

    @if (errorMessage) {
        <div class="alert alert-danger" role="alert"><strong>Error:</strong> {{ errorMessage }}</div>
    }

    @if (result) {
        <!-- Header Information -->
        <div class="row mb-3">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        <strong>PO Header Information</strong>
                        @if (uploadedFileName) {
                            <span class="text-muted ms-2">— extracted from {{ uploadedFileName }}</span>
                        }
                    </div>
                    <div class="card-body">
                        <div class="row">
                            @for (field of headerFields; track field.label) {
                                <div class="col-md-4 col-lg-3 mb-2">
                                    <small class="text-muted d-block">{{ field.label }}</small>
                                    <span>{{ field.value }}</span>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Totals -->
        @if (result.totals) {
            <div class="row mb-3">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header"><strong>Totals</strong></div>
                        <div class="card-body">
                            <div class="row">
                                @if (result.totals.subtotal != null) {
                                    <div class="col-md-3 mb-2">
                                        <small class="text-muted d-block">Subtotal</small>
                                        <span>{{ result.totals.subtotal | currency }}</span>
                                    </div>
                                }
                                @if (result.totals.taxAmount != null) {
                                    <div class="col-md-3 mb-2">
                                        <small class="text-muted d-block">Tax</small>
                                        <span>{{ result.totals.taxAmount | currency }}</span>
                                    </div>
                                }
                                @if (result.totals.freightAmount != null) {
                                    <div class="col-md-3 mb-2">
                                        <small class="text-muted d-block">Freight</small>
                                        <span>{{ result.totals.freightAmount | currency }}</span>
                                    </div>
                                }
                                @if (result.totals.grandTotal != null) {
                                    <div class="col-md-3 mb-2">
                                        <small class="text-muted d-block">Grand Total</small>
                                        <strong>{{ result.totals.grandTotal | currency }}</strong>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }

        <!-- Line Items Grid -->
        @if (result.lineItems && result.lineItems.length > 0) {
            <div class="row">
                <div class="col-12">
                    <h4>Line Items ({{ result.lineItems.length }})</h4>
                    <div class="row action-toolbar">
                        <div class="col-12">
                            <form class="form-inline">
                                <action-toolbar-count [grid]="grid"></action-toolbar-count>
                            </form>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <wj-flex-grid
                                id="lineItemsGrid"
                                #lineItemsGrid
                                appAutoSize
                                (initialized)="grid.initialize(lineItemsGrid)"
                                (destroy)="grid.destroy()"
                                [itemsSource]="grid.view"
                                [isReadOnly]="true"
                            >
                                <wj-flex-grid-filter></wj-flex-grid-filter>
                                <wj-flex-grid-column [header]="'#'" [binding]="'lineNumber'" [width]="60"></wj-flex-grid-column>
                                <wj-flex-grid-column [header]="'Item Code'" [binding]="'itemCode'" [width]="120"></wj-flex-grid-column>
                                <wj-flex-grid-column [header]="'Description'" [binding]="'description'" [width]="'*'"></wj-flex-grid-column>
                                <wj-flex-grid-column [header]="'UOM'" [binding]="'unitOfMeasure'" [width]="80"></wj-flex-grid-column>
                                <wj-flex-grid-column [header]="'Quantity'" [binding]="'quantity'" [format]="'n2'" [width]="100"></wj-flex-grid-column>
                                <wj-flex-grid-column [header]="'Unit Price'" [binding]="'unitPrice'" [format]="'c'" [width]="110"></wj-flex-grid-column>
                                <wj-flex-grid-column [header]="'Line Total'" [binding]="'lineTotal'" [format]="'c'" [width]="120"></wj-flex-grid-column>
                                <wj-flex-grid-column [header]="'GL/Account'" [binding]="'glAccountCode'" [width]="120"></wj-flex-grid-column>
                            </wj-flex-grid>
                        </div>
                    </div>
                </div>
            </div>
        }
    } @else if (!isProcessing && !errorMessage) {
        <div class="alert alert-info" role="alert">
            Click the <strong>Upload PO</strong> button above to upload a purchase order document. Supported formats include PDF, images, Word, Excel, and text files.
        </div>
    }
</div>
